import { initReporterInstance } from './core/tracerProvider';
import { setMetricPrefix } from './metrics/creates';
import { setKnownRoutes } from './route';
import { initWebVitalsReporting } from './webVitals';
import { initResourceMetrics } from './resourceMetrics';
import { initErrorTracking } from './errorTracking';
import { trackSession, trackPageView } from './pageTracking';

let initialized = false;

export function initShopeepayReporter(config) {
  if (initialized) {
    console.warn('[@shopeepay/reporter] Already initialized, skipping.');
    return initReporterInstance(config);
  }
  initialized = true;

  setMetricPrefix(config.metricPrefix || 'spp');
  setKnownRoutes(config.knownRoutes);

  const reporter = initReporterInstance(config);

  initWebVitalsReporting();
  initResourceMetrics();
  initErrorTracking(config.maxErrorsPerSession);

  trackSession(config.sessionStorageKey || 'spp_session');
  trackPageView();

  return reporter;
}
